export const APP_TIME_ZONE = "America/Toronto";

const LOCALE = "en-US";

function asDate(value) {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isFinite(date.getTime()) ? date : null;
}

export function appDateParts(value) {
  const date = asDate(value);
  if (!date) return null;
  const parts = new Intl.DateTimeFormat("en-CA-u-ca-gregory-nu-latn", {
    timeZone: APP_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    hourCycle: "h23",
  }).formatToParts(date);
  return Object.fromEntries(parts.filter(({ type }) => type !== "literal")
    .map(({ type, value: part }) => [type, Number(part)]));
}

export function appDayKey(value) {
  const parts = appDateParts(value);
  return parts ? `${parts.year}-${String(parts.month).padStart(2, "0")}-${String(parts.day).padStart(2, "0")}` : "";
}

export function formatAppDate(value, options = {}) {
  const date = asDate(value);
  if (!date) return "";
  return new Intl.DateTimeFormat(LOCALE, {
    month: "long",
    day: "numeric",
    ...options,
    timeZone: APP_TIME_ZONE,
  }).format(date);
}

export function formatAppTime(value, options = {}) {
  const date = asDate(value);
  if (!date) return "";
  const timeOptions = { ...options };
  delete timeOptions.second;
  return new Intl.DateTimeFormat(LOCALE, {
    hour: "numeric",
    minute: "2-digit",
    ...timeOptions,
    timeZone: APP_TIME_ZONE,
  }).format(date);
}

export function formatAppDateTime(value, { dateOptions = {}, timeOptions = {} } = {}) {
  const date = asDate(value);
  if (!date) return "";
  const dateLabel = formatAppDate(date, { year: "numeric", ...dateOptions });
  const timeLabel = formatAppTime(date, timeOptions);
  return dateLabel && timeLabel ? `${dateLabel} at ${timeLabel}` : "";
}
